
import './app.css'
import Accordion from "./components/Accordion"
import {useState,useEffect} from 'react'
import {useNavigate} from "react-router-dom";
import Switch from "./components/Switch"
import SendData from "./SendData"


//import {SendData} from "./HomeApp"

function Modal ({boards,onSelect,onClose}){
  return (
    <div className="modal"  /*style={overlayerStyle}*/>
      <div style={modalStyle}>
        <h3 className="board-item">
          انتخاب گلخانه
        </h3>
        {
            boards.map ( (board,key)=>{
              return(
            <div
              key={key}
              onClick={()=>{onSelect (board,key);}}
              /*style={itemStyle}*/
              className="board-item"
              >
              {board.name}
            </div>
          )})
       }
        <button   style={style.button}  /*style={{backgroundColor:'#0ff',}}*/ onClick={onClose} >
          کنسل
        </button>
      </div>
    </div>
  );
}

const overlayerStyle = {
  position:'fixed',
  top:0,
  left:0,
  right:0,
  bottom:0,
  background: "rgba (0,0,0,0,5)",
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex:1000
};

const modalStyle = {
  background: '#fff',
  padding:20,
  borderRadius:8,
  width:'80%',
  maxWidth:300
};

const itemStyle = {
  padding: '10px',
  borderBottom: '1px solid #eee',
  cursor: 'pointer'
};





function MainApp ({socket}){
  const [code,setCode] = useState ("");
  const id=localStorage.getItem ('id');
  const phone=localStorage.getItem ('phone');
  const units=JSON.parse(localStorage.getItem ('units'));
  const [select_unit,setSelect_unit]= useState (localStorage.getItem ('select_unit'));
  const [seletedUnit,setSelectedUnit]=useState(units[select_unit]);
  const [showModal,setShowModal]=useState(false);
  const [data,setData] = useState ({});
  const navigate = useNavigate ();
  useEffect (()=>{
    if (!socket)return;
    SendData (socket,'get_unit',{unit:42});
/*
    socket.on ('message',(data)=>{
      window.alert ('data')
      setData (data)
      if (data.event==='phone_undefined')window.alert('شماره وارد شده نا معتبر می باشد')
      if (data.event==='code_send') window.alert(data.data);
    });*/
    socket.on ('message',(dat)=>{
      const da=JSON.parse(dat);
      if (da.board_id==seletedUnit.id && da.event=='data')
      {
        setData (JSON.parse(dat));
      }
      if (da.event=='code_ok')
      {
        if (da.data!=null && da.data._id!=null)
        {
          if (da.data.units!=null)
          {

            navigate ("/MainApp");
          }else{
            window.alert ('شما به هیچ دستگاهی دسترسی ندارید')
            navigate ("/GetPhone");
          }
        }else {
          window.alert ('کد وارد شده اشتباه است')
        }
      }

    })



  return () =>{
    socket.off ('message');
  };

},[socket,select_unit]);


  return (
    <div  className="page" /* style={style.container}*/>

      <div className="row" >
        <div
          className="small-btn"
          onClick = {()=>{setShowModal (true);}}
          >
          {seletedUnit.name}
        </div>
        <div
          className="small-btn"
          style={{width: '5%',color:'red'}}
          onClick = {()=>{setShowModal (true);}}
          >
          {'X'}
        </div>
        <div
          className="small-btn"
          style={{width: '20%'}}
          onClick = {()=>{setShowModal (true);}}
          >
          {

        ((data!=null && data.time!=undefined && data.time.hours!=undefined && data.time.minutes!=undefined)
          ? (data.time.hours+':'+data.time.minutes)
          : '00:00')
        }
      </div>

      </div>

      <div className="content" >
      <Accordion title = {"هواشناسی"}>
      <div  className="row" >

      <h2 style={{ fontSize:20 , textAlign:'center' ,margin:2 , flex:.4 }} >
          {
            (data.sensor_out!=null)
              ? ((isFinite(data.sensor_out[2])) ? Number((data.sensor_out[2]).toFixed(1))+" Km/s" : data.sensor_out[2])
            : 'ERR'
          }
        </h2>
        <h2 style={{ fontSize:20 , textAlign:'center' ,margin:2 , flex:.4 }} >
        {
          (data.sensor_out!=null)
            ? ((isFinite(data.sensor_out[0])) ? Number((data.sensor_out[0]).toFixed(1))+" 'c " : data.sensor_out[0])
          : 'ERR'
        }
        </h2>
        <h2 style={{ fontSize:20 , textAlign:'center' ,margin:2 , flex:.4 }} >
        {
          (data.sensor_out!=null)
            ? ((isFinite(data.sensor_out[1])) ? Number((data.sensor_out[1]).toFixed(1))+" % " : data.sensor_out[1])
          : 'ERR'
        }
        </h2>
        </div>


      </Accordion>

      <Accordion title = {
        'دما : '+((data.m_temp!=undefined && isFinite(data.m_temp)) ? (Number(data.m_temp).toFixed (1)+' درجه') : '---')+'   ,   '+'رطوبت : '+ ((data.m_humid!=undefined && isFinite(data.m_humid)) ? (Number(data.m_humid).toFixed (1)+' درصد ') : '---')

      }>
      {
        (data.sensor!=undefined) ?
        data.sensor.map ((value,key)=>{
          return (
          <div key={key}  className="row" >
          <h2 style={{ fontSize:20 , textAlign:'center' ,margin:2 , flex:.4 }} >
            {':'+'سنسور '+(key+1)}
          </h2>
          <h2 style={{ fontSize:20 , textAlign:'center' ,margin:2 , flex:.3 }} >
            {(isFinite(value[0])) ? Number((value[0]).toFixed(1))+" `C" :value[0]}
          </h2>
          <h2 style={{ fontSize:20 , textAlign:'center' ,margin:2 , flex:.3 }} >
            {(isFinite(value[1])) ? Number((value[1]).toFixed(1))+" %" :value[1]}
          </h2>
          </div>
        );
      }) : null
      }



      </Accordion>

      <div style={{ backgroundColor:'#09f',margin:0 ,marginTop:4,padding:2, borderRadius:20,}}>
        <div  className="row">

          <div style = {{alignSelf:'right',flex:.6 }}>
            <h2 style={{  color: "white", fontSize:24, alignSelf:'left' ,textAlign:'center',margin:2 ,marginLeft:10,marginRight:10 }}>
              {
                (data.hoter_auto!=undefined && data.hoter_auto==false) ? "بخاری ها دستی" : "بخاری ها"
              }
            </h2>
          </div>
          <div style = {{alignSelf:'right',flex:.4 }}>

            <h2 style={{fontSize:24 , color:'white', textAlign:'center',flex:.4,margin:2}}>
              کولر ها
            </h2>
         </div>
       </div>

     <div className='row' >

     <div style={{margin:4, borderRadius:15,flex:.6,  backgroundColor:'#0ff'}}>
     {
       (data.hoter!=undefined) ?
       data.hoter.map ((value,key)=>{
       return (
         <div key={key} className='row'>
         <h2 style={{fontSize:24 , textAlign:'center',margin:4,flex:.2 , color:(data.active_hoter!=undefined && data.active_hoter[key]==false)?"red":"black"}} >{key+1}</h2>
         <div style={{fontSize:24 , textAlign:'center',margin:4,flex:.2}} >
         <Switch
           value={value}
           onChange={ () =>{if (data.hoter_auto==0){ data.hoter[key]=!value;    SendData (socket,'data',{"event":"seting_data","data":{"hoter":data.hoter} } );} }}
          />
          </div>
          <div style={{fontSize:24 , textAlign:'center',margin:4,flex:.2}} >
          <Switch type='checkbox'
            value={(data.hoter_fan!=undefined && data.hoter_fan[key]!=undefined) ? data.hoter_fan[key] : false }
            onChange={ () =>{
              if (data.hoter_auto==0)
              {
                if (data.hoter_fan!=undefined)data.hoter_fan[key]=!((data.hoter_fan!=undefined && data.hoter_fan[key]!=undefined) ? data.hoter_fan[key] : false);
                SendData (socket,'data',{"event":"seting_data","data":{"hoter_fan":data.hoter_fan} } );
              }
            }}
           />
           </div>
           <div style={{fontSize:24 , textAlign:'center',margin:4,flex:.2}} >
           <Switch type='checkbox'
             value={data.fb_hoter[key]}
            />
            </div>

           </div>
        );
       }) : null
     }
     </div>

     <div style={{margin:4, borderRadius:15,flex:.4,  backgroundColor:'#0ff'}}>
     {
       (data.coler!=undefined) ?
       data.coler.map ((value,key)=>{
       return (
         <div key={key} className='row'>
         <h2 style={{fontSize:24 , textAlign:'center',margin:4,flex:.4}} >{key+1}</h2>
         <div style={{fontSize:24 , textAlign:'center',margin:4,flex:.6}} >
         <Switch
           value={value}
           onChange={ () =>{if (data.hoter_auto==0){ data.coler[key]=!value;    SendData (socket,'data',{"event":"seting_data","data":{"coler":data.coler} } );} }}
          />
          </div>
           </div>
        );
       }) : null
     }


     </div>

     </div>

     { (data.window!=null)?
     <div style={{ margin:4, borderRadius:15,flex:.8,  backgroundColor:'#0ff'}}>
      <div style={{padding:2}}>
       <div className='row' style={{flexDirection:'row' ,margin:4, borderRadius:15,flex:.5,  backgroundColor:'#09f'}}>
       <div style={{ fontSize:20 ,color:'white', alignSelf:'center' ,padding:5,paddingLeft :40 , flex:.3 }}>
       <Switch type='checkbox'
           value={(data.window!=undefined) ? data.window.fb_close : false}
       />
       </div>
       <h2 style={{ fontSize:20 ,color:'white', alignSelf:'center' ,margin:2 , flex:.7 }} >
       {
         (data.window!=undefined && data.window.open !=undefined)
         ? (
             (data.window.open>0)
             ? (' پنجره ها '+data.window.open+' %باز میباشد ')
             : (' پنجره ها بسته میباشد ')
           ) : (' وظعیت پنجره نا مشخص ')
       }
       </h2>
       </div>
       </div>
       <div className='row' style={{ marginLeft:5,marginRight:5, borderRadius:15,flexDirection:'row', alignSelf:'center',alignItems:'center',  backgroundColor:'#0ff'}}>
       {
         (data.window!=undefined && data.window.fb!=undefined) ?
         data.window.fb.map ((value,key)=>{
         return (
           <div key={key} style={{flexDirection:'row'}}>
           <Switch type='checkbox'
               value={data.window.fb[key]}
           />
           </div>
        );
       }) : null
       }
       </div>
       <h2 style={{ fontSize:20 , textAlign:'center',alignSelf:'center' ,margin:2,padding:5  }} >
         {(data.window!=undefined && data.window.text!=undefined) ? data.window.text : '------'}
       </h2>
     </div>
     :null}

    { (data.fan_humid!=null)?
     <div style={{ margin:4, borderRadius:15,flex:.5,  backgroundColor:'#0ff'}}>
         <div style={{padding:2}}>
           <div className='row' style={{flexDirection:'row' ,margin:4, borderRadius:15,flex:.5,  backgroundColor:'#09f'}}>
             <div style={{ color:'white', alignSelf:'center' ,paddingRight:0,paddingLeft :50 , flex:.3 }}>
               <Switch
                 value={(data.fan_humid!=undefined && data.fan_humid.on!=undefined)?data.fan_humid.on : false}
                 onChange={ () =>{SendData (socket,'data',{"event":"seting_data","data":{"fan_humid":{"on":!((data.fan_humid!=undefined && data.fan_humid.on!=undefined)?data.fan_humid.on : false)}}}); }}
               />
             </div>
             <h2 style={{fontSize:20 , textAlign:'center' ,flex:.7 ,color:'white',margin:2}} >فن تخلیه رطوبت</h2>
           </div>
           <h2 style={{ fontSize:20 , textAlign:'center',alignSelf:'center' ,margin:2,padding:5  }} >
             {(data.fan_humid!=undefined && data.fan_humid.text!=undefined) ? data.fan_humid.text : '------'}
           </h2>
         </div>
      </div>
      :null}


      { (data.mah_pash!=null)?
      <div style={{ margin:4, borderRadius:15,flex:.5,  backgroundColor:'#0ff'}}>
        <div style={{padding:2}}>
          <div className='row' style={{flexDirection:'row' ,margin:4, borderRadius:15,flex:.5,  backgroundColor:'#09f'}}>
            <div style={{ color:'white', alignSelf:'center' ,paddingRight:0,paddingLeft :50 , flex:.3 }}>
              <Switch
                value={(data.mah_pash!=undefined && data.mah_pash.on!=undefined)?data.mah_pash.on : false}
                onChange={ () =>{SendData (socket,'data',{"event":"seting_data","data":{"mah_pash":{"on":!((data.mah_pash!=undefined && data.mah_pash.on!=undefined)?data.mah_pash.on : false)}}}); }}
              />
            </div>
            <h2 style={{fontSize:20 , textAlign:'center' ,flex:.7 ,color:'white',margin:2}} >مه پاش</h2>
          </div>
          <h2 style={{ fontSize:20 , textAlign:'center',alignSelf:'center' ,margin:2,padding:5  }} >
            {(data.mah_pash!=undefined && data.mah_pash.text!=undefined) ? data.mah_pash.text : '------'}
          </h2>
        </div>
     </div>
     :null}



     { (data.sir_cole!=null)?
     <div style={{ margin:4, borderRadius:15,flex:.5,  backgroundColor:'#0ff'}}>
       <div style={{padding:2}}>
         <div className='row' style={{flexDirection:'row' ,margin:4, borderRadius:15,flex:.5,  backgroundColor:'#09f'}}>
           <div style={{ color:'white', alignSelf:'center' ,paddingRight:0,paddingLeft :50 , flex:.3 }}>
             <Switch
               value={(data.sir_cole!=undefined && data.sir_cole.on!=undefined)?data.sir_cole.on : false}
               onChange={ () =>{SendData (socket,'data',{"event":"seting_data","data":{"sir_cole":{"on":!((data.sir_cole!=undefined && data.sir_cole.on!=undefined)?data.sir_cole.on : false)}}}); }}
             />
           </div>
           <h2 style={{fontSize:20 , textAlign:'center' ,flex:.7 ,color:'white',margin:2}} >سیرکوله</h2>
         </div>
         <h2 style={{ fontSize:20 , textAlign:'center',alignSelf:'center' ,margin:2,padding:5  }} >
           {(data.sir_cole!=undefined && data.sir_cole.text!=undefined) ? data.sir_cole.text : '------'}
         </h2>
       </div>
    </div>
    :null}


    { (data.fan_pad!=null)?
    <div style={{ margin:4, borderRadius:15,flex:.5,  backgroundColor:'#0ff'}}>
      <div style={{padding:2}}>
        <div className='row' style={{flexDirection:'row' ,margin:4,padding:3, borderRadius:15,flex:.3,  backgroundColor:'#09f'}}>
        <div className='row' style={{ color:'white', alignSelf:'center',paddingRight:0,paddingLeft :0 , flex:.3 }}>
          <h2 style={{fontSize:20 , textAlign:'center' ,flex:.2 ,color:'white',margin:2}} >{" فن "}</h2>
          <Switch
            value={(data.fan_pad!=undefined && data.fan_pad.fan!=undefined && data.fan_pad.fan>0)?true : false}
            onChange={ () =>{SendData (socket,'data',{"event":"seting_data","data":{"fan_pad_fan":{"on":!((data.fan_pad!=undefined && data.fan_pad.fan!=undefined)?data.fan_pad.fan : false)}}}); }}
          />
        </div>
        <div className='row' style={{ color:'white', alignSelf:'center' ,paddingRight:0,paddingLeft :0 , flex:.3 }}>
          <h2 style={{fontSize:20 , textAlign:'center' ,flex:.2 ,color:'white',margin:2}} >{" پمپ "}</h2>
          <Switch
            value={(data.fan_pad!=undefined && data.fan_pad.pump!=undefined)?data.fan_pad.pump : false}
            onChange={ () =>{SendData (socket,'data',{"event":"seting_data","data":{"fan_pad_pump": { "on" : !((data.fan_pad!=undefined && data.fan_pad.pump!=undefined )? data.fan_pad.pump : false )} }}); }}
          />
        </div>
          <h2 style={{fontSize:20 , textAlign:'center' ,flex:.5 ,color:'white',margin:2}} >{" فن و پد "}</h2>
        </div>
        <h2 style={{ fontSize:20 , textAlign:'center',alignSelf:'center' ,margin:2,padding:5  }} >
          {(data.fan_pad!=undefined && data.fan_pad.text!=undefined) ? data.fan_pad.text : '------'}
        </h2>
      </div>
   </div>
   :null}

   { (data.sam_pash!=null)?

    <div style={{ margin:4, borderRadius:15,flex:.5,  backgroundColor:'#0ff'}}>
      <div style={{padding:2}}>
        <div className='row' style={{flexDirection:'row' ,margin:4, borderRadius:15,flex:.5,  backgroundColor:'#09f'}}>
          <div style={{ color:'white', alignSelf:'center' ,paddingRight:0,paddingLeft :50 , flex:.3 }}>
            <Switch
              value={(data.sam_pash!=undefined && data.sam_pash.on!=undefined)?data.sam_pash.on : false}
              onChange={ () =>{SendData (socket,'data',{"event":"set_data","data":{"sam_pash":{"on":!((data.sam_pash!=undefined && data.sam_pash.on!=undefined)?data.sam_pash.on : false)}}}); }}
            />
          </div>
          <h2 style={{fontSize:20 , textAlign:'center' ,flex:.7 ,color:'white',margin:2}} >سم پاش</h2>
        </div>
      </div>
   </div>
   :null}




       </div>




      {
        showModal && (
      <Modal
        boards={units}
        onSelect={(unit,key)=>{setSelectedUnit (unit); setSelect_unit (key); setData ({}); localStorage.setItem('select_unit', key+''); setShowModal(false);}}
        onClose={()=>{setShowModal(false);}}/>

      )}
      <button className="btn2" /* style={style.button}*/
        onClick ={()=>{
          navigate ('/MainSetting');
        }}>
          تنظیمات
      </button>
      {
        /*
      <button className="btn2"
        onClick ={()=>{
        }}>
         مشاهذه سابقه
      </button>
      */
      }
    </div>
    </div>
  );


}
const style={
  container:{
  //  minHeight:"100vh",
    display:"flex",
    alignItems:"center",
    padding:16,
    backgroundColor:"#00f7f7"
  },
  content:{

    width:"100%",
    maxWidth:420,
    display:"flex",
    flexDirection:"column",
    gap:12,
    marginTop:10
  },
  input:{
    width:"90%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
//    border:"1px solid #ccc"
  },
  button:{
    width:"100%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
    border:"nune",
    backgroundColor:"#1976d2",
    coloe:"#fff",
    cursor:"pointer"
  },
  text:{
    alignItems:"center",
    textAlign:"center",
    width:"90%",
    padding:14,
    fontSize:24,
    borderRadius:8,
    border:"nune",
  //  backgroundColor:"#1976d2",
    coloe:"#fff",
//    cursor:"pointer"
  }

}

export default MainApp;
